import { UseFormReturn } from "react-hook-form";
import AppFormInput from "../../../../components/form/app-form-input";
import AppFormRadioGroup, { RadioOption } from "../../../../components/form/app-form-radio-group";
import { EditMidForm, CommissionValueType } from "./edit-mid.types";
import './edit-mid.part.form.commission-field.scss';

interface EditMidPartFormCommissionFieldProps {
    form: UseFormReturn<EditMidForm>;
    commissionName: `commissions.${number}`; 
    label: string;
    secondaryLabel: string;
}


const EditMidPartFormCommissionField: React.FC<EditMidPartFormCommissionFieldProps> = ({
    form,
    commissionName,
    label,
    secondaryLabel,
}) => {
    const radioOptions: RadioOption<string>[] = [
        { value: CommissionValueType.PERCENT, text: 'Percent' },
        { value: CommissionValueType.FIXED, text: 'Fixed $' },
    ];

    return (
        <div className="commission-item flex-column flex-gap-15">
            <div className="label">{label} <span>({secondaryLabel})</span></div>
            <div className="flex-row flex-gap-20 flex-align-space-between-center">
                <div className="commission-field-value">
                    <AppFormInput
                        control={form.control}
                        name={`${commissionName}.value` as const}
                        type="number"
                        placeholder="Value"
                        min={0}
                        validations={{ required: true }}
                    />
                </div>
                <div className="commission-field-type">
                    <AppFormRadioGroup
                        control={form.control}
                        name={`${commissionName}.valueType` as const}
                        options={radioOptions}
                        validations={{ required: true }}
                    />
                </div>
              
            </div>
          
          
        </div>
    );
};

export default EditMidPartFormCommissionField;
